<template>
  <el-dialog custom-class="invoice-audit" title="发票审核" width="500px" :close-on-click-modal="false" :visible.sync="visible">
    <el-form ref="form" label-width="100px" size="small" :model="form">
      <el-form-item label="审核状态" prop="auditStatus">
        <el-radio-group v-model="form.auditStatus">
          <el-radio v-for="(item, index) in auditStatusAll" :key="index" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="拒绝理由" prop="refuseReason" v-show="form.auditStatus === 0">
        <el-input placeholder="请填写拒绝理由，最多不超过100字" maxlength="100" type="textarea" v-model="form.refuseReason"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="invoice-footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { auditStatusAll } from '@/utils/enum';

export default {
  name: 'addInvoceApply',
  data() {
    return {
      visible: false,
      auditStatusAll,
      form: {
        invoiceId: '',
        auditStatus: 1,
        refuseReason: '',
      },
    };
  },
  methods: {
    show(invoice) {
      this.form.invoiceId = invoice.invoiceApplyId;
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.visible = false;
    },
    handleCancel() {
      this.close();
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.auditStatus === 1) {
            this.form.refuseReason = '';
          }
          this.$emit('confirm', this.form);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.invoice-audit {
  /deep/ .el-dialog__body {
    padding: 20px 20px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice/components/invoiceAudit.vue